const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 59,
    viewBox: "0 0 58 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_304_1445",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 34,
    y: 5,
    width: 22,
    height: 21
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.6875 5.13184H55.3234V25.7528H34.6875V5.13184Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_304_1445)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.5102 25.7528C52.5991 25.7528 51.8161 25.0689 51.7122 24.1433C50.7963 15.9846 44.4598 9.65297 36.2987 8.74672C35.3054 8.63555 34.5877 7.74139 34.6989 6.74572C34.8076 5.75247 35.6945 5.02022 36.6999 5.14589C46.555 6.24064 54.2086 13.8846 55.313 23.7373C55.4242 24.733 54.7089 25.6296 53.7156 25.7407C53.6479 25.748 53.5779 25.7528 53.5102 25.7528Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.9557 25.7782C44.1051 25.7782 43.3487 25.1788 43.1795 24.3137C42.4835 20.737 39.7261 17.9796 36.1542 17.286C35.1707 17.0951 34.5302 16.1453 34.7212 15.1618C34.9121 14.1782 35.8787 13.5353 36.8454 13.7287C41.8745 14.705 45.7581 18.5862 46.7368 23.6177C46.9277 24.6037 46.2873 25.5534 45.3062 25.7443C45.1877 25.7661 45.0717 25.7782 44.9557 25.7782Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.94643 10.1785L8.12176 9.99523C12.7797 5.33688 15.813 4.10213 19.0494 5.96323C19.9804 6.49859 20.8532 7.24796 22.04 8.45334L25.6804 12.2282C27.6911 14.4223 28.1482 16.5269 27.4935 18.9916L27.4033 19.3178L27.3032 19.6423L26.8165 21.0701C25.7749 24.2721 26.2098 26.0787 29.9157 29.7837C33.7696 33.6366 35.5685 33.9518 39.0176 32.7466L39.6323 32.5329L40.3756 32.2915L40.7009 32.2012C43.3206 31.5023 45.5336 32.06 47.8806 34.4054L50.8138 37.2387L51.6772 38.0879C52.6345 39.0641 53.2672 39.8376 53.7345 40.6551C55.584 43.8906 54.3479 46.9221 49.5556 51.6965L49.0997 52.1584C48.3842 52.848 47.7157 53.342 46.7337 53.8083C45.0852 54.591 43.1377 54.8861 40.8747 54.5714C35.2983 53.7959 28.2258 49.396 19.2641 40.4366C18.5346 39.7073 17.8359 38.9921 17.1673 38.2907L15.8701 36.9062C3.71462 23.6997 2.64226 15.587 7.6237 10.499L7.94643 10.1785ZM19.1043 10.6465C18.317 9.87024 17.7451 9.39707 17.2408 9.10711C16.1255 8.46574 14.9213 8.73685 12.6926 10.655L11.9923 11.2806C11.8702 11.3934 11.7453 11.5104 11.6174 11.6319L10.8144 12.414L10.7421 12.5044L10.1977 13.0513C8.88217 14.395 8.25904 16.0349 8.79601 18.8553C9.67714 23.4832 13.7103 29.7613 21.8255 37.8744C30.2811 46.3279 36.7236 50.3358 41.3724 50.9823C44.0825 51.3592 45.4648 50.7029 46.8746 49.2587L47.9496 48.1738C48.4537 47.6463 48.8845 47.1681 49.2482 46.7313L49.7443 46.1062C51.0123 44.4173 51.1281 43.4041 50.5858 42.4555C50.3795 42.0945 50.0794 41.6988 49.6425 41.2152L49.0498 40.5892L48.6991 40.2382L44.9986 36.6649C43.762 35.5246 42.9169 35.3628 41.6338 35.7051L41.2634 35.8116L39.7305 36.332C35.2836 37.7682 32.0755 37.0718 27.3512 32.3487C22.4584 27.4571 21.8845 24.1905 23.5239 19.4872L23.6291 19.185L23.9199 18.3088L24.0629 17.7503C24.3164 16.5348 24.027 15.6873 22.7203 14.3804C22.6665 14.3266 22.6064 14.266 22.541 14.1996L19.1043 10.6465Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCall);
export default __webpack_public_path__ + "static/media/icon-call.799649295f031131d45f9a7ecb623679.svg";
export { ForwardRef as ReactComponent };